'use client'

import { useProduct } from '@shopify/hydrogen-react'
import { useMemo } from 'react'

import { env } from '@/env'
import { ProductTracker } from 'analyzify-js/react'

import { toStorefrontProduct } from './Analyzify.adapters'
import { isAnalyzifyEnabled } from './Analyzify.constants'

import type { PriceOverride } from './Analyzify.adapters'
import type { ProductFragment } from '@/types/shopify/storefront'

type AnalyzifyProductTrackerProps = {
  product: ProductFragment
  /** Variant on the landing URL; the selected variant takes over from there. */
  variantId?: string
  priceOverride?: PriceOverride
}

const Tracker = ({ product, variantId, priceOverride }: AnalyzifyProductTrackerProps) => {
  const { selectedVariant } = useProduct()
  const storefrontProduct = useMemo(() => toStorefrontProduct(product, priceOverride), [product, priceOverride])

  return <ProductTracker product={storefrontProduct} variantId={selectedVariant?.id ?? variantId} />
}

/** Fires view_item for the product page. Renders nothing. */
export const AnalyzifyProductTracker = (props: AnalyzifyProductTrackerProps) => {
  if (!isAnalyzifyEnabled(env.NEXT_PUBLIC_ANALYZIFY_MODE)) return null

  return <Tracker {...props} />
}
